import React from 'react'
import { required } from 'ra-core'
import LocalizedRichInputText from 'ui-shared/LocalizedFields/LocalizedRichInputText'
type Props = {
  source?: string
}
const DescriptionInput: React.FC<Props> = ({ source = 'description' }) => {
  return (
    <LocalizedRichInputText
      source={source}
      label="form.fields.description"
      validate={required()}
      fullWidth
    />
  )
}

export default DescriptionInput
